export const advise = () =>
    `<div class="lightBlue"><p>If you need advice from me, you can book a time slot in <a target="_blank" href="https://calendly.com/paolomeola">my calendar</a>.</p>` +
    `</br>` +
    `<p>Just make sure to provide me with <span class="lightRed">all details and relevant information</span> I may need to help you.</p></div>`;